import React ,{Component} from 'react';
import { Navigate  } from 'react-router-dom';
import axios from 'axios';

import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';
import TableBody from '@mui/material/TableBody'; 

import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import { addDays } from "date-fns";
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox'; 
import FormControlLabel from '@mui/material/FormControlLabel'; 

import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ReactToPrint from 'react-to-print';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
//import { styled } from '@mui/material/styles';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SummarizeIcon from '@mui/icons-material/Summarize';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import BrowserNotSupportedOutlinedIcon from '@mui/icons-material/BrowserNotSupportedOutlined';	          
 import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import Uploadfile from './Uploadfile';
import Sharelink from './Sharelink';
import Payment from './Payment';
import PaymentRefBox from './Paymentdetails';

import Sendemail from './Sendemail';
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(100%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 100,
});


const useStyles = styled({   
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
  

  table: {
    minWidth: 750,
  },
  
});



function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}


function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}



export default class Salesinvoicevewmore extends Component {
	
    constructor(props) {
    super(props);
	
 this.state = {open:false, addopen: false,invoiceid:'',entrydate:'',
	 sin_reference:'',invoiceId:'',
	invoicedate:'',productviewData:[],lastdate:'',cu_id:'',cu_emailid:'',
	 invoiceData:[],page:0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],paycount:0,paytext:"payments",
search:'',order:'desc' ,orderBy:'se_id',customername:'',invoiveduedate:'',totalamount:0,outstandingamt:0,grandtotal:"0.00",salesshippingamt:0,
	  
	urllink:'',activeStep:0,active:'',setactiveStep:0,taxbrkupsarr:[],taxsumarr:[],subtotal:"0.00",taxid:'',sin_status:'',sinemailstatus:'',sin_invoiceno:'',sin_pdffile:'',invoiceclass:'icon-default',prevfile:"",
		
	}
	      this.updateDonenewParent=this.updateDonenewParent;  
	}
	
	
 updateDonenewParent = (event) => {
	 this.InvoiceViewmore();
	 }
	
componentWillMount() { 
let search = window.location.href;
let Sinoid = this.getParameterByName('sinoid', search);



	
if(localStorage.getItem("ISIuserid")===null)
		 {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
		let strname="Sales Invoice";
		   
	this.props.parentdasCallback(
           strname+"~"
        );
		if(Sinoid!=null)
		{
	  this.InvoiceViewmore();
		}
}






 getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}



Productgetall(sinoid) {
	axios.get(localStorage.getItem("ISIurl") + 'ajaxsaleinvoiceproduct.php?action=getall&sorting=iop_id&iop_sin_id=' + sinoid)
		.then(resp => {
			if (resp.data.length > 0) {
				this.setState({
					productviewData: resp.data,
						totaldata: parseInt(resp.data[0].count),
				}, () => {
					
					this.Taxcalculate();
					this.GetTotalById(sinoid);
					
					
				});
			} else {
				this.setState({
					productviewData: [],
					totaldata: 0
				});
			}
		})
		
}


handleClickOpen = (e) => { 
  this.setState({addeopn:!this.state.addeopn,
	  });
	  
		
};

InvoiceViewmore() {

 let search = window.location.href;
    let Sinoid = this.getParameterByName('sinoid', search);



    axios.get(localStorage.getItem("ISIurl") + 'ajaxsalesinvoice.php?action=getall&sin_id='+Sinoid)
        .then(resp => {
            if (resp.data.length > 0) {
              let strclas='icon-default';
			  if(resp.data[0].sin_status==="4")
			  {
				 strclas='icon-tick'; 
			  }
			  
                this.setState({
                    invoiceData: resp.data,entrydate:resp.data[0].sin_createddate,
                  invoiceId:resp.data[0].sin_id,
				     sin_id:resp.data[0].sin_id,cu_emailid:resp.data[0].cu_emailid,
					 invoicedate:resp.data[0].invoicedate,
					 reference:resp.data[0].sin_reference,
					 customername:resp.data[0].cu_contactname,
                    invoiveduedate:resp.data[0].invoiveduedate,
					sin_status:resp.data[0].sin_status,
					cu_id:resp.data[0].sin_cu_id,
					invoiceclass:strclas,salesshippingamt:resp.data[0].sin_shippingcharges,
					sin_invoiceno:resp.data[0].sin_invoiceno,
sin_pdffile:resp.data[0].sin_pdffile,prevfile:resp.data[0].sin_file,
                },()=>{
					
					
					
				});
					 let strname="Sales Invoice: "+resp.data[0].sin_invoiceno;
		   
	 this.props.parentdasCallback(
         strname+"~"
     );
				  this.Productgetall(resp.data[0].sin_id); 
            } else {
                this.setState({ invoiceData: []});
            }
        });
}

handlAddfileopen = () => {
        
  this.refs.Uploadfile.handleaddfileClose();
}
   
	
	
	   

onSelectedTaxbyid(txid,taxarr){
	
		 axios.get(localStorage.getItem("ISIurl")+'ajaxtax.php?action=taxid&tx_id='+txid+'&tx_cmp_id='+localStorage.getItem("ISIcmpid")+'&dwt_fromdate='+this.state.entrydate)
  .then(resp => {  
    let strarraytax=[];
	
   if(resp.data.length>0){
	   
  
	
	var rowsArrayp = resp.data;
 
	 rowsArrayp.map((txrow, j) => {
	const taxitems = {
        taxname:txrow.tx_name,
         taxmid:txrow.tx_mainid,
		 taxper:txrow.dwt_percentage,
          taxamt:0 ,
		   taxablevalue:0
        };
		strarraytax.push(taxitems);
		});
		let sretax= Object.values(taxarr);
		
		let mergedarray = strarraytax.map(function(item) {
    sretax.map(function(item2) {
        if (item.taxmid == item2.taxid) {
            item.taxamt=item2.total;
			 item.taxablevalue=((parseFloat(item2.total)*parseFloat(item.taxper))/100).toFixed(2);
			
        }
    });
  return item;
   });

	this.setState({ taxbrkupsarr:mergedarray})


	   
   }
   
   
  });

}
Taxcalculate(){
	let optionstaxRep = this.state.productviewData;
let profit=0.00,strsubtotal=0.00,strdiscount=0.00;
	

let previoustax="",strcurnttax="",prerow=0,taxablevalue=0,rate="",totaltaxamt=0,taxamount=0,totalamount=0;
	let  strgrantotal=0,strtotaldiscount=0;
	
let strtaxid="",strsep="";

const arr = optionstaxRep;

const out = {};

for (const { salesprice,qty,discount, taxid,tax } of arr) {
  out[taxid] ??= { taxid, total: 0,taxamt:0 };
  const subtotal = out[taxid].total + ((parseFloat(salesprice)* parseFloat(qty))-parseFloat(discount));
   const taxtotal = out[taxid].taxamt + Number(tax);
   strtaxid=strtaxid+strsep+taxid;
		strsep=",";
  out[taxid] = { ...out[taxid], total: subtotal,taxamt:taxtotal };
}

this.onSelectedTaxbyid(strtaxid,out);


    optionstaxRep.forEach(eachrep => {
		 
			strsubtotal  =parseFloat(strsubtotal)+parseFloat(eachrep.total)
	
		strgrantotal=parseFloat(strgrantotal)+parseFloat(eachrep.total)
		profit=parseFloat(profit)+parseFloat(eachrep.costtotal)
		strdiscount=parseFloat(strdiscount)+parseFloat(eachrep.discount)
	
		
	});
strgrantotal=parseFloat(strgrantotal)+parseFloat(this.state.salesshippingamt)
	 this.setState({subtotal:parseFloat(strsubtotal).toFixed(2),grandtotal:parseFloat(strgrantotal).toFixed(2),Grndtotal: parseFloat(strgrantotal).toFixed(2),
						outstandingamt: parseFloat(strgrantotal).toFixed(2)});
}


handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  }; 
   
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };
 
  
    handleRequestSort = (event, property) => 
	{
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};

handlestatusupdate = (e) =>{

				 var formData = new FormData(); 
					 formData.append('action','statusupdate')
					formData.append('sin_id',this.state.invoiceId)
					 formData.append('userid',localStorage.getItem("ISIuserid"))
					 formData.append('sin_status',5)
				 axios.post(localStorage.getItem("ISIurl")+"ajaxsalesinvoice.php", formData, {
	
	
	})
		 
	
}






handleaddfileClose = (e) => { 
  this.setState({addopen:!this.state.addopen,
	  });
	 		
}
Deletesalesinvoice= (e) =>{  

		let r = window.confirm("Do you really want to Delete?");
		 if(r === true){ 
				 var formData = new FormData(); 
					 formData.append('action','delete')
					
					 formData.append('sin_id',this.state.invoiceId)
					 formData.append('userid',localStorage.getItem("ISIuserid"))
				
					  axios.post(localStorage.getItem("ISIurl")+"ajaxsalesinvoice.php", formData, {
						 
						}).then(res => { 
						
						if(res.data === 1)
{ 
	
					this.setState({redirect:true,pagename:'/Adminsalesinvoice'});
}					
						})
		 }
 }








/*paymentgetall */

GetTotalById(sinoid) {
  axios.get(localStorage.getItem("ISIurl") + 'ajaxpayments.php?action=gettotal&pmt_type=3&pref_mainid=' + sinoid)
    .then(resp => {
      if (resp.data.length > 0) {
   

        this.setState({
        lastdate:resp.data[0].lasttransaction,
       totalamount:parseFloat(resp.data[0].totalpaid).toFixed(2),

		outstandingamt: (parseFloat(this.state.outstandingamt) - parseFloat(resp.data[0].totalpaid)).toFixed(2),

      paycount:resp.data[0].cnt,

	  },()=>{
		 
		
	  });
      } 
	  
	  
	  
	  
	  else {
        this.setState({ totalamount: 0 });
      }
	  
	  
	  
    });
}


 handleAddpayment = () => {
	
	this.refs.Payment.handleaAddpaymentClose();
}
 


/**/




   addpayrefbox(){
    let search = window.location.href;
   
    setTimeout(() => this.refs.PaymentRefBox.handleClickOpen(),500);

 }





	render() {
		
		
	let search = window.location.href;
    let Sinoid = this.getParameterByName('sinoid', search);

	
	let totalitem=0;
	let grandTotal=0;
	let subtaotal = 0;
	let outstandingamount=0;
	let balanceamoutn=0;
	
	
	
	
    return (
	
<React.Fragment>	



  <div className="estimateviewcontainer">
    <div className="estimateviewerleftbox">
      <div className="estimateviewmorebox">
        <div className="custgreencolor">
          To: <span className="lighgreencolor">{this.state.customername}</span>
        </div>
        
        <div className="estaddressdata">
          <Table width="100%">
            <tr>		
              <td align="left" style={{"width": "10%"}}>	
                {this.state.invoiceData.map((item,index) => { 
                  return (
                    <React.Fragment>
                      <div className="invoiceaddress">
                       
                          <p><b>Invoice Address</b> <br/>
                          {item.sin_billingaddress1}<br/>
                          {item.sin_billingaddress2}<br/>
                          {item.sin_billingcity}<br/>
						  {item.sin_billingstate} - {item.sin_billingpincode}</p>
                        
                      </div>
                    </React.Fragment>
                  );
                })}
              </td>

              <td align="left" style={{"width": "10%"}}>
                {this.state.invoiceData.map((item,index) => { 
                  return (
                    <React.Fragment>
                      <div className="invoiceaddress">
                        <p><b>Delivery Address</b><br/>
                          {item.sin_shippingaddress1}<br/>
                          {item.sin_shippingaddress2}<br/>
                          {item.sin_shippingcity}<br/>
                          {item.sin_shippingstate} - {item.sin_shippingpincode}</p>
                       
                      </div>
                    </React.Fragment>
                  );
                })}
              </td>

              <td align="left" style={{"width": "10%"}}> 
                <p><b>Created Date</b></p>
                <p>{this.state.invoicedate}</p>
              </td>

              <td align="left" style={{"width": "10%"}}> 
                <p><b>Expires</b></p>
                <p>{this.state.invoiveduedate}</p>
              </td>

              <td align="left" style={{ width: "10%" }}>
                {this.state.reference && (
                  <>
                    <p><b>Reference</b></p>
                    <p>{this.state.reference}</p>
                  </>
                )}
              </td>
            </tr>
          </Table>
        </div>
		
				

	
	<PaymentRefBox 
ref="PaymentRefBox"   pmt_type={3}
outstandingamt={this.state.outstandingamt}

pref_mainid={this.state.sin_id}

/>
 
		
		
		
		
<Payment ref="Payment" 

           pref_mainid={this.state.sin_id}
cu_id={this.state.cu_id}
          sin_status={this.state.sin_status}
          Grndtotal={this.state.outstandingamt}
updateDonenew={this.updateDonenewParent}
			   pmt_type={3}
			   
			   
			   />


		
		
		
		
        
        <div ref={el => (this.componentRef = el)}  >
          <Paper>
            <TableContainer className="table-container">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className="table-head">Item Description</TableCell>
                    <TableCell className="table-head">Qty</TableCell>
                    <TableCell className="table-head ">Price</TableCell>
                    <TableCell className="table-head ">Discount</TableCell>
                    <TableCell className="table-head ">Tax</TableCell>
                    <TableCell className="table-head ">Sub Total</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {stableSort(this.state.productviewData, getSorting(this.state.orderBy, this.state.order)).map((item, index) => {
                    subtaotal = Number(subtaotal) + Number(item.iop_total);
                    totalitem = Number(totalitem) + Number(item.iop_quantity);
                    return (
                      <React.Fragment key={index}>
                        <TableRow className="table-cell" style={{ backgroundColor: '#f1f5f6' }}>
                          <TableCell className="table-cell">
                            <p>{item.iop_description}</p>
                            <p><i>{item.ledgername}({item.le_code})</i></p>
                          </TableCell>
                          <TableCell className="table-cell">{item.iop_quantity}</TableCell>
                          <TableCell className="table-cell"> {Number(item.iop_price).toFixed(2)}</TableCell>
						  <TableCell className="table-cell">{item.iop_discount}</TableCell>
                          
                          <TableCell className="table-cell"><p>{Number(item.iop_taxvalue || 0).toFixed(2)}</p><p>{item.tx_name}</p> </TableCell>
                          <TableCell className="table-cell"> {Number(item.iop_total || 0).toFixed(2)} $</TableCell>
                        </TableRow>
                      </React.Fragment>
                    );
                  })}

				  {this.state.productviewData.length>0 &&(
				  <React.Fragment>
                  <TableRow>
                    <TableCell colSpan="4"></TableCell>
                    <TableCell><b>Sub Total</b></TableCell>
                    <TableCell align="left">$.{parseFloat(this.state.subtotal).toFixed(2)} </TableCell>
                  </TableRow>
 <TableRow>
                    <TableCell colSpan="4"></TableCell>
                    <TableCell><b>Shipping Charges</b></TableCell>
                    <TableCell align="left">$.{parseFloat(this.state.salesshippingamt).toFixed(2)} </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell colSpan="4"></TableCell>
                    <TableCell><b>Tax Breakdown</b>
						{this.state.taxbrkupsarr.length>0 && (<React.Fragment>
		<div className="taxdiv">
		{this.state.taxbrkupsarr.map((rows,i) => {


				
           return ( <React.Fragment>
		   
		<p ><b>{rows.taxname}: {rows.taxamt}  @ {rows.taxper}%</b></p> 
	
		   </React.Fragment>)
		   
		})}
	</div></React.Fragment>
		)}
					</TableCell>
                    <TableCell align="left">{this.state.taxbrkupsarr.length>0 && (<React.Fragment>
		
		{this.state.taxbrkupsarr.map((rows,i) => {


				
           return ( <React.Fragment>
		   
		 <p >{rows.taxablevalue}</p>
	
		   </React.Fragment>)
		   
		})}
	</React.Fragment>
		)}</TableCell>
                  </TableRow>


                  <TableRow>
                    <TableCell colSpan="4"></TableCell>
                    <TableCell><b><h4>Total</h4></b>({totalitem}) Items</TableCell>
                    <TableCell align="left">$.{(parseFloat(this.state.grandtotal)).toFixed(2)}</TableCell>
                  </TableRow>
				    </React.Fragment>
				  )}
				  
				   {this.state.productviewData.length===0 &&(
				  
                            <TableRow>
                             <TableCell  >
                               No Products Found
                             </TableCell>
                            </TableRow>
                   )}
				  
				  
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
       </div>
      </div>
    </div>








    <div className="estimateviewerightbox">
      
	  <div className="invoiceupdatebox">
	  
		<div className="stepperheader">		
		<div className="carbon-pod__content"><div className="s1a-timeline-container"><div className="s1a-timeline-pip-container"><span className="carbon-icon s1a-timeline-pip-icon icon-tick" aria-label="created" data-component="icon" data-element="tick" tabindex="0"></span><div className="s1a-timeline-pip-title"><span>created</span></div></div><div className="s1a-timeline-pip-container"><span className="carbon-icon s1a-timeline-pip-icon icon-default" aria-label="sent" data-component="icon" data-element="default"></span><div className="s1a-timeline-pip-title"><span>sent</span></div></div><div className="s1a-timeline-pip-container"><span className="carbon-icon s1a-timeline-pip-icon icon-default" aria-label="viewed" data-component="icon" data-element="default"></span><div className="s1a-timeline-pip-title"><span>viewed</span></div></div>
 {this.state.sestatus==="4" && (
<div className="s1a-timeline-pip-container"><span className={"carbon-icon s1a-timeline-pip-icon "+ this.state.invoiceclass} aria-label="invoiced" data-component="icon" data-element="default"></span><div className="s1a-timeline-pip-title"><span>Paid</span></div></div>

 )}
 {this.state.sestatus!=="4" && (
<div className="s1a-timeline-pip-container"><span className={"carbon-icon s1a-timeline-pip-icon icon-default"} aria-label="invoiced" data-component="icon" data-element="default"></span><div className="s1a-timeline-pip-title"><span>Paid</span></div></div>

 )}
</div></div>
	  </div>
	  
	  </div>
	  
	  
	  
	  
 <div className="invoiceupdatebox">
	  <div className="stepperheader">	
	  <div className="amountpaidbox">
	     <p><b>Amount Paid</b></p>
		  <h4><b>$ {this.state.totalamount}</b></h4>
	     {this.state.totalamount!=0 && (
	    	<p><span className="greentextcolor">{this.state.paycount}&nbsp;
	
	     	<span className="paytext" onClick={()=>{this.addpayrefbox()}}>{this.state.paytext}</span> 	&nbsp;</span> on {this.state.lastdate}</p>
	       )}
	
	  </div>
		
		
		
		
		<div className="outstadingpaybox">
		
		<p><b>Amount Outstanding</b></p>
		<h4>${this.state.outstandingamt}</h4>
		
		</div>
		
		<div className="clear"></div>
	   {this.state.sin_status!=="4" && (
		<div className="createinvoicebox">
		  <h3 onClick={this.handleAddpayment}>Record Payment </h3>
		  
		</div>
	   )}
	   
	   </div>
	  </div>

	  
	  
	 
	  

	  
	
		
		   <div className="invoiceupdatebox">
		     <div className="Viewfunctionality">
            <ul>
             <li >
            <p onClick={()=>{this.refs.Sharelink.handlSharebox()}}>
                <ShareOutlinedIcon className="verticalalign"/> &nbsp; Share Link
            </p>
             </li>
			 
			 <li>
            <p >
               <a href={localStorage.getItem("ISIurl")+"uploads/"+this.state.sin_pdffile} target="_blank" ><LocalPrintshopOutlinedIcon className="verticalalign"/> &nbsp; Print Preview
			</a>
            </p>  
             </li>
			 
			  {this.state.sestatus!=="3" && ( 
			 <li>
            <p onClick={this.handlAddfileopen}>
            <AttachFileOutlinedIcon className="verticalalign"/> &nbsp; Add file
          </p>

             </li>)}
			   {this.state.prevfile!="" && (
		     <li><p className="icon-text" >
		  <AttachFileOutlinedIcon className="verticalalign"/> <a href={localStorage.getItem("ISIurl")+"uploads/"+this.state.prevfile} target="_blank">View File</a>
		 </p>  </li>)}
			   
			 <li>
            <p onClick={()=>{this.refs.Sendemail.handleaddfileClose()}}>
			
                <MailOutlinedIcon className="verticalalign"/> &nbsp; Email
				
            </p>
             </li>
			    {this.state.sin_status!=="4" && (
			  <li>
            <p >
                <a className="link" href={"#/Addsalesinvoice?sinid="+this.state.invoiceId+""}><EditOutlinedIcon className="verticalalign"/> &nbsp; Edit
            </a></p>
             </li>
				)}
			   <li>
            <p >
                <a  
			    href={localStorage.getItem("ISIurl")+"uploads/"+this.state.sin_pdffile}
              
                target="_blank"
                rel="noreferrer"  ><CloudDownloadOutlinedIcon className="verticalalign"/>&nbsp; Download</a>
            </p>
			</li>

           <li>
            <p >
               <a className="link" href={"#/Addsalesinvoice?sinid="+this.state.invoiceId+"&copy=1"}> <ContentCopyOutlinedIcon className="verticalalign"/>&nbsp; Copy</a>
            </p>
			</li> <li>
            <p > <a className="link" href={"#/AddSalescreditnotes?cr_sinid="+this.state.invoiceId}> 
			<SummarizeIcon className="verticalalign"/> Add Credit Note</a>
			 </p>
			</li>
       <li>
            <p >
               <a  
			    href={localStorage.getItem("ISIurl")+"uploads/packingslip-"+this.state.invoiceId+".pdf"}
                
                target="_blank"
                rel="noreferrer"> <LocalShippingOutlinedIcon className="verticalalign"/>&nbsp; Print Packing slip</a>
            </p>
			</li>   {this.state.sin_status!=="4" && (
			<li>
            <p onClick={this.Deletesalesinvoice}>
              <DeleteOutlineOutlinedIcon className="verticalalign"/>&nbsp; Delete
            </p>
			</li>
			)}
		 {this.state.sin_status!=="5" && (
		 <li>
            <p  onClick={this.handlestatusupdate}>
              <BrowserNotSupportedOutlinedIcon className="verticalalign"/>&nbsp; Void
            </p>
			</li>
			)}
			
             </ul>
               </div>
  </div>
	
	  
	  
	  
    </div>
  </div>

  <div className="clear"></div>
  

  

  
  
 <Sharelink ref="Sharelink" />
  


<Sendemail ref="Sendemail"  headingname="Sales Invoice"
aoid="8"
  id={this.state.invoiceId} emailid={this.state.cu_emailid}   />


       <Uploadfile ref="Uploadfile"id={this.state.invoiceId}  strrtype={2} updateDonenew={this.updateDonenewParent}/>

  

  
</React.Fragment>
    );
}

}